"use strict";

(function () {
  window.km_antiSpamInputAddElementById = function (id) {
    const input = document.getElementById(id);
    antiSpamInputProcess(input);
  };
  const antiSpamInputProcess = function (input) {
    input.value = input.getAttribute('data-anti-spam-token');

    //const tr = input.parentElement.parentElement.parentElement;
    //tr.style.display = 'none';
  };
  onDOMReady(function () {
    const elements = document.getElementsByClassName('antiSpamInput');
    for (let i = 0; i < elements.length; i++) {
      antiSpamInputProcess(elements[i]);
    }
  });
})();

// jQuery free